import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      component: require("../pages/admin/Layout").default,
      children: [
        {
          path: "/",
          name: "project-list",
          component: require("../pages/admin/project/List").default,
          meta: {
            title: "Projekte"
          }
        },
        {
          meta: {
            title: "Projekt bearbeiten"
          },
          path: "/projects/edit/:projectId",
          component: require("../pages/admin/project/Edit").default,
          children: [
            {
              path: "/",
              name: "project-edit",
              component: require("../pages/admin/project/General").default
            },
            {
              path: "micropages",
              name: "project-edit-micropage",
              component: require("../pages/admin/block/List").default
            },
            {
              path: "results",
              name: "project-edit-results",
              component: require("../pages/admin/result/List").default
            },
            {
              path: "results/:resultId",
              name: "project-edit-result",
              component: require("../pages/admin/result/Edit").default
            },
            {
              path: "micropages/blocks/:blockId",
              name: "project-edit-block",
              component: require("../pages/admin/block/Edit").default
            }
          ]
        },
        {
          path: "/projects/create/",
          component: require("../pages/admin/project/Create").default,
          name: "project-create"
        },
        {
          path: "/umbrella_projects",
          name: "umbrella-project-list",
          component: require("../pages/admin/umbrella_project/List").default,
          meta: {
            title: "Verbundprojekte"
          }
        },
        {
          path: "/umbrella_projects/edit/:projectId",
          component: require("../pages/admin/umbrella_project/Edit").default,
          children: [
            {
              path: "/",
              name: "umbrella-project-edit",
              component: require("../pages/admin/project/General").default
            },
            {
              path: "micropages",
              name: "umbrella-project-edit-micropage",
              component: require("../pages/admin/block/List").default
            },
            {
              path: "results",
              name: "umbrella-project-edit-results",
              component: require("../pages/admin/result/List").default
            },
            {
              path: "results/:resultId",
              name: "umbrella-project-edit-result",
              component: require("../pages/admin/result/Edit").default
            },
            {
              path: "projects",
              name: "umbrella-project-edit-projects",
              component: require("../pages/admin/umbrella_project/ProjectList")
                .default
            },
            {
              path: "micropages/blocks/:blockId",
              name: "umbrella-project-edit-block",
              component: require("../pages/admin/block/Edit").default
            }
          ]
        },
        {
          path: "/umbrella_projects/create/",
          component: require("../pages/admin/umbrella_project/Create").default,
          name: "umbrella-project-create"
        },
        {
          path: "/results",
          name: "result-list",
          component: require("../pages/admin/result/GeneralList").default
        },
        {
          path: "/results/edit/:resultId",
          component: require("../pages/admin/result/GeneralEdit").default,
          children: [
            {
              path: "/",
              name: "result-edit",
              component: require("../pages/admin/result/Edit").default
            }
          ]
        },
        {
          path: "/results/create",
          name: "result-create",
          component: require("../pages/admin/result/GeneralCreate").default
        },
        {
          path: "/key_themes",
          name: "key-theme-list",
          component: require("../pages/admin/key_theme/List").default,
          meta: {
            title: "Themenschwerpunkte"
          }
        },
        {
          path: "/key_themes/edit/:keyThemeId",
          component: require("../pages/admin/key_theme/Edit").default,
          children: [
            {
              path: "/",
              name: "key-theme-edit",
              component: require("../pages/admin/key_theme/General").default
            },
            {
              path: "chapters",
              name: "key-theme-chapter-list",
              component: require("../pages/admin/synthesis/chapter/List")
                .default
            },
            {
              path: "end-event",
              component: require("../pages/admin/event/Edit").default,
              props: { routeName: "key-theme-synthesis-end-event" },
              children: [
                {
                  path: "/",
                  name: "key-theme-synthesis-end-event",
                  component: require("../pages/admin/event/General").default
                },
                {
                  path: "results",
                  name: "key-theme-synthesis-end-event-results",
                  component: require("../pages/admin/result/List").default
                },
                {
                  path: "result/:resultId",
                  name: "key-theme-synthesis-end-event-result",
                  component: require("../pages/admin/result/Edit").default
                }
              ]
            }
          ]
        },
        {
          path: "/key_themes/create/",
          component: require("../pages/admin/key_theme/Create").default,
          name: "key-theme-create"
        },
        {
          path: "/chapters/edit/:chapterId",
          component: require("../pages/admin/synthesis/chapter/Edit").default,
          children: [
            {
              path: "/",
              name: "synthesis-chapter-edit",
              component: require("../pages/admin/synthesis/chapter/General")
                .default
            },
            {
              path: "sub-chapters",
              name: "synthesis-sub-chapter-list",
              component: require("../pages/admin/synthesis/sub_chapter/List")
                .default
            }
          ]
        },
        {
          path: "/sub-chapter/edit/:subChapterId",
          component: require("../pages/admin/synthesis/sub_chapter/Edit")
            .default,
          children: [
            {
              path: "/",
              name: "synthesis-sub-chapter-edit",
              component: require("../pages/admin/synthesis/sub_chapter/General")
                .default
            },
            {
              path: "cards",
              name: "synthesis-card-list",
              component: require("../pages/admin/synthesis/card/List").default
            }
          ]
        },
        {
          path: "/cards/edit/:cardId",
          component: require("../pages/admin/synthesis/card/Edit").default,
          children: [
            {
              path: "/",
              name: "synthesis-card-edit",
              component: require("../pages/admin/synthesis/card/General")
                .default
            },
            {
              path: "micropages",
              name: "card-edit-micropage",
              component: require("../pages/admin/block/List").default
            },
            {
              path: "micropages/blocks/:blockId",
              name: "card-edit-block",
              component: require("../pages/admin/block/Edit").default
            }
          ]
        },
        {
          path: "/dossiers",
          name: "dossier-list",
          component: require("../pages/admin/dossier/List").default,
          meta: {
            title: "Dossiers"
          }
        },
        {
          path: "/dossiers/edit/:dossierId",
          component: require("../pages/admin/dossier/Edit").default,
          children: [
            {
              path: "/",
              component: require("../pages/admin/dossier/General").default,
              name: "dossier-edit"
            },
            {
              path: "chapters",
              name: "dossier-chapter-list",
              component: require("../pages/admin/synthesis/chapter/List")
                .default
            },
          ]
        },
        {
          path: "/dossier/create/",
          component: require("../pages/admin/dossier/Create").default,
          name: "dossier-create"
        },
        {
          path: "/program_resumee",
          name: "program-resumee",
          component: require("../pages/admin/program_resumee/Edit").default,
          meta: {
            title: "Programm Resümee"
          },
          children: [
            {
              path: "/",
              name: "program-resumee-edit",
              component: require("../pages/admin/program_resumee/General").default,
              meta: {
                title: "Programm Resümee"
              }
            },
            {
              path: "micropages",
              name: "program-resumee-edit-micropage",
              component: require("../pages/admin/block/List").default
            },
            {
              path: "micropages/blocks/:blockId",
              name: "program-resumee-edit-block",
              component: require("../pages/admin/block/Edit").default
            }
          ]
        },        

        {
          path: "/tags",
          component: require("../pages/admin/tag/List").default,
          meta: {
            title: "Tags"
          },
          name: "tag-list"
        },
        {
          path: "/tags/edit/:tagId",
          component: require("../pages/admin/tag/Edit").default,
          name: "tag-edit"
        },
        {
          path: "/tags/create/",
          component: require("../pages/admin/tag/Create").default,
          name: "tag-create"
        },
        {
          path: "/infoboxes",
          component: require("../pages/admin/infobox/List").default,
          meta: {
            title: "Infoboxen"
          },
          name: "infobox-list"
        },
        {
          path: "/infoboxes/edit/:infoboxId",
          component: require("../pages/admin/infobox/Edit").default,
          name: "infobox-edit"
        },
        {
          path: "/infoboxes/create/",
          component: require("../pages/admin/infobox/Create").default,
          name: "infobox-create"
        },
        {
          path: "/partners",
          component: require("../pages/admin/partner/List").default,
          meta: {
            title: "Partner"
          },
          name: "partner-list"
        },
        {
          path: "/partners/edit/:partnerId",
          component: require("../pages/admin/partner/Edit").default,
          name: "partner-edit"
        },
        {
          path: "/partners/create/",
          component: require("../pages/admin/partner/Create").default,
          name: "partner-create"
        },
        {
          path: "/users",
          component: require("../pages/admin/user/List").default,
          meta: {
            title: "Benutzer"
          }
        },
        {
          path: "/users/edit/:userId",
          name: "user-edit",
          component: require("../pages/admin/user/Form").default,
          meta: {
            title: "Benutzer bearbeiten"
          }
        },
        {
          path: "/users/create",
          name: "user-create",
          component: require("../pages/admin/user/Form").default,
          meta: {
            title: "Benutzer erstellen"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js